import { forEach } from '../functions';
import mustache from 'mustache/mustache.min.js';
import configureSearchInput from '../helpers/configure-search-input';

const hideClass = 'gds-visibility--hide';

const KEY_CODE_MAP = {
  TAB: 9,
  ENTER: 13,
  ESC: 27
};

const templateStringTown = `
  <div class="lookup-tool-results__town">
    <div class="lookup-tool-results__top">
      <h1 class="lookup-tool-results__heading">{{post_title}}</h1>
      <button class="gds-button gds-button-circle gds-secondary" aria-label="close" data-action="advisor-search--close"></button>
    </div>
    {{&offices}}
  </div>
  `;

const templateStringOffice = `
  <div class="lookup-tool-results__office">
    {{#office_name}}
      <h2 class="lookup-tool-results__subheading--service-center">{{office_name}}</h2>
    {{/office_name}}
    {{#office_address}}
      <p>{{&office_address}}</p>
    {{/office_address}}
    <h2 class="lookup-tool-results__subheading--post-type-name">Advisors</h2>
    <div class="lookup-tool-results__result-values">
      {{&advisors}}
    </div>
  </div>
  `;

const templateStringAdvisor = `
  <div class="lookup-tool-results__result-value">
    {{#thumb}}
      <div class="lookup-tool-results__result-value--image-container">
        <img class="" src="{{.}}" />
      </div>
    {{/thumb}}
    <div class="lookup-tool-results__result-value--info">
      {{#title}}
        <h3 class="lookup-tool-results__result-value--title">{{title}}</h3>
      {{/title}}
      {{#phone}}
        <p class="lookup-tool-results__result-value--phone">{{&phone}}</p>
      {{/phone}}
      {{#email}}
        <a class="lookup-tool-results__result-value--email" href="mailto:{{email}}" target="_blank">{{email}}</a>
      {{/email}}
      {{#towns}}
        <p class="lookup-tool-results__result-value--town">Communities served in whole or part: {{towns}}</p>
      {{/towns}}
    </div>
  </div>
  `;

const templateNoAdvisorsFound = `
  <div>There is not yet an advisor assigned to your town.</div>
  `;

const onAdvisorSearchSelection = function (feedback) {
  feedback.event.preventDefault();

  const params = {
    action: 'gmp_get_advisors',
    town_id: feedback.selection.value.id
  }

  const url = site.url + '/wp-admin/admin-ajax.php?' + jQuery.param(params);

  jQuery.get(url, [], function (response) {
    let offices = "";
    forEach(response.offices, function (i, office) {
      let advisors = "";
      if (!office.advisors) {
        return;
      }
      forEach(office.advisors, function (i, advisor) {
        advisors = advisors + mustache.render(templateStringAdvisor, advisor);
      });
      office.advisors = advisors;
      offices = offices + mustache.render(templateStringOffice, office);
    });
    const town = response.town;
    if (!offices) {
      offices = mustache.render(templateNoAdvisorsFound);
    }
    town.offices = offices;
    jQuery('#energy-advisors .results').show();
    const resultsDiv = document.querySelector('#energy-advisors .results');
    resultsDiv.innerHTML = mustache.render(templateStringTown, town);
    jQuery('#advisor-search-results-window').addClass(hideClass);
  });
};

const closeAdvisorSearch = function () {
  const resultsDiv = jQuery('#energy-advisors .results');
  if (undefined == resultsDiv) return;
  resultsDiv.hide();
  jQuery('#advisor-search-input').val('');
}

export default function init() {
  configureSearchInput(
    '.lookup-tool__search-form',
    '#advisor-search-input',
    '#advisor-search-results-window',
    false,
    ['&subtype=town', '&post_type=town'],
    onAdvisorSearchSelection,
    true
  );
  jQuery('#advisor-search-bar-close').hide();
  jQuery('#energy-advisors .results').hide();
  jQuery('#advisor-search-input').on("input", function () {
    if (jQuery(this).val().length > 0) {
      jQuery('#advisor-search-bar-close').show();
    } else {
      jQuery('#advisor-search-bar-close').hide();
    }
  });
  jQuery(document).on('click', '[data-action="advisor-search--close"]', function (event) {
    event.preventDefault()
    closeAdvisorSearch();
  });

}
